import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { LoaderService } from 'src/app/services/loader.service';
import { KryptoService } from 'src/app/services/krypto.service';
import { Settlement } from '../../interfaces/merchant';

@Component({
  selector: 'app-krypto-edit',
  templateUrl: './krypto-edit.component.html',
  styleUrls: ['./krypto-edit.component.scss']
})
export class KryptoEditComponent implements OnInit {

  krypto: any;
  formDataKrypto: FormGroup;
  settlements: Settlement[] = [];
  idKrypto = this.aR.snapshot.paramMap.get('id') ? this.aR.snapshot.paramMap.get('id') : null;

  constructor(
    private fb: FormBuilder,
    private aR: ActivatedRoute,
    private loaderService: LoaderService,
    private kryptoService: KryptoService
  ) {
    this.createFormDataKrypto();
    this.getKrypto();
  }

  ngOnInit(): void {
  }

  createFormDataKrypto() {
    this.formDataKrypto = this.fb.group({
      description: ['',Validators.required],
      usage: ['',Validators.required],
      expirationDate: [null]
    })
  }

  updateKrypto(data) {
    this.loaderService.updateLoading(true);
  }

  getKrypto(){
    this.loaderService.updateLoading(true);
    this.kryptoService.keyById(this.idKrypto).subscribe((res:any) => {
        this.loaderService.updateLoading(false);
        this.krypto = res;
    }, () => {
        this.loaderService.updateLoading(false);
    })
  }

}
